<template>
  <section class="header">
    <img class="navbar__logo header__mobile-logo" src="/images/logo_blanc.svg" />

    <div>
      <p class="header__text">
        {{ section.description }}
      </p>
    </div>

    <img
      src="https://assets.boitebeet.com/restaurantophelia/37/animation-op-hd.gif"
      class="header__image"
      alt=""
    />

    <div class="header__button">
      <button class="button" @click="openReservations()">
        {{ $t('reservation') }}
      </button>

      <div class="header__mobile-call">
        <a class="link text" :href="`tel:${$beet.options.contact.phone}`"
          >{{ $t('call') }}<br />{{ $beet.options.contact.phone }}</a
        >
      </div>
    </div>
  </section>

  <section class="section-gradient">
    <div class="section-gradient__container">
      <div class="section-gradient__container__bg" v-reveal>
        <img
          class="section-gradient__container__img"
          :src="`/images/video_text_${$i18n.locale}.png`"
          width="440"
          height="460"
          alt="Entrez chez Ophelia et vivez le contraste de la terre et de la mer. Un décor, une ambiance, un service et une expérience culinaire aux saveurs qui se démarquent."
        />
        <video
          class="section-gradient__container__video"
          src="https://assets.boitebeet.com/restaurantophelia/38/waves.webm"
          width="660"
          height="660"
          loop
          autoplay
          muted
          alt="votre navigateur ne support pas les vidéos."
          v-if="mq.mdPlus"
          v-reveal
        />
        <img
          class="section-gradient__container__video"
          src="https://assets.boitebeet.com/restaurantophelia/36/waves.gif"
          v-else
          width="660"
          height="660"
          loop
          autoplay
          muted
          alt="votre navigateur ne support pas les gif animé."
          v-reveal
        />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionHeader',
  inject: ['mq'],
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openReservations() {
      window.open(
        'https://www.opentable.ca/booking/restref/availability?lang=en-CA&correlationId=87f0eac8-62c2-485c-b32b-297ac5ce6e74&restRef=1147108&otSource=Other',
        '_blank',
      )
    },
  },
}
</script>
